import { Table } from '@shared/Table'
import { Grid, Row, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { orderListColumns as defaultOrderListColumns } from '../../constants/orderList.columns'
import OrderDetailsModal from '../OrderDetailsModal'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { useDispatch } from 'react-redux'
import { setXrfValue } from 'store/actions/salaryCard/setXrfValue.actions'
import { useTranslation } from 'react-i18next'
import { Modal } from '@shared/Modal/Modal'
import {
  businessCardOrderApi,
  useBusinessCardListQuery,
  useBusinessCardOrderDetailMutation,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import { ModalErrorIco } from '@modules/CustomIcons'

function BusinessCardList() {
  const brp = Grid.useBreakpoint()
  const isSmallScreen = brp.xl

  const [open, setOpen] = useState(false)
  const originalArgs = useAppSelector(
    (state) => state.api.queries.fetchBusinessCardList?.originalArgs
  )
  const {
    isSuccess,
    isFetching,
    data: salaryCardList,
  } = useBusinessCardListQuery(originalArgs, { skip: !originalArgs })

  const dispatch = useDispatch()
  const { t } = useTranslation()
  const orderListColumns = defaultOrderListColumns()
  const [
    fetchOrderDetails,
    { data, isSuccess: isSuccessOD, isLoading, isError, error },
  ] = useBusinessCardOrderDetailMutation({
    fixedCacheKey: 'businessCardOrderDetail',
  })

   const onCloseModal = () => {
    setOpen(!open)
  }

  let title: React.ReactNode = t('common.loading')
  let content = (
    <Spin
      size="large"
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    />
  )

  if (isError) {
    title = t('common.attention')
    content = (
      <Row
        align="middle"
        justify="center"
        style={{ flexDirection: 'column', textAlign: 'center', height: '100%' }}
      >
        <ModalErrorIco />
        <Typography.Text style={{ fontSize: 18, marginTop: 20, color: 'gray' }}>{error.data}</Typography.Text>
      </Row>
    )
  }

  if (isSuccessOD) {
    title = (
      <>
        {`${data?.orderNo} №-${t(
          'orders.salaryCardOrder.tableTitles.tableTitles'
        )} - "`}
        <Typography.Text strong>
          {t(
            `businessCardOrders.buttonsLabels.RadioButtonGroup.${data?.status}`
          )}
        </Typography.Text>
        {'"'}
      </>
    )
    content = <OrderDetailsModal onCloseModal={onCloseModal} />
  }

  const onOpenModal = (record: any) => {
    setOpen(!open)
    dispatch(setXrfValue(record.orderNo))
    fetchOrderDetails({ orderNo: record.orderNo })
  }

  useEffect(() => {
    return () => {
      dispatch(businessCardOrderApi.util.resetApiState())
    }
  }, [])

  return (
    <>
      <Row style={{ flexDirection: 'column' }}>
        <Table
          loading={isFetching}
          tableKey="businessCardTable"
          sticky
          editColumns={orderListColumns}
          pagination={false}
          dataSource={isSuccess ? salaryCardList.orderList : []}
          {...(isSuccess
            ? {
                scroll: { x: 1500 },
                responsive: true,
              }
            : {})}
          size="small"
          rowKey={(record) => record.orderNo}
          hideSelectAll
          selected={true}
          onClickRow={onOpenModal}
        />
        <Modal
          {...(isLoading
            ? { width: 500 }
            : { width: isSmallScreen ? 'calc(100vw - 25%)' : '100%' })}
          {...(isError ? { width: 500 } : {})}
          open={open}
          centered
          title={title}
          footer={null}
          confirmLoading={true}
          onClose={onCloseModal}
        >
          {content}
        </Modal>
      </Row>
    </>
  )
}

export default BusinessCardList
